module.exports = __webpack_public_path__ + "static/media/customstore-mobile.fb41a572.webp";